import React from 'react';
import { Button } from '../ui/button';

export const PreviewPane = ({ gameHtml, session, runtimeError, rollbackNotice, onCommit, onRestore }) => (
  <div className="space-y-4">
    <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl p-4 border border-white/10">
      <div className="flex items-center justify-between mb-2">
        <h2 className="text-white font-semibold">Live Preview</h2>
        <div className="flex items-center gap-2">
          {rollbackNotice && (
            <span
              data-testid="rollback-notice"
              className="text-[10px] px-2 py-1 rounded bg-amber-900/60 text-amber-100 border border-amber-500/60"
            >
              New build crashed — rolled back to last working version
            </span>
          )}
          {runtimeError && !rollbackNotice && (
            <span className="text-[10px] px-2 py-1 rounded bg-red-900/60 text-red-100 border border-red-500/60">
              Runtime error: {runtimeError.message}
            </span>
          )}
          <Button
            variant="outline"
            size="sm"
            data-testid="save-as-game-btn"
            disabled={!session}
            onClick={onCommit}
            className="border-green-500 text-green-400 hover:bg-green-500/10"
          >
            Save as Game
          </Button>
        </div>
      </div>
      <div className="border border-white/10 rounded-lg overflow-hidden bg-black h-[360px]">
        {gameHtml ? (
          <iframe
            title="Game preview"
            className="w-full h-full border-0"
            sandbox="allow-scripts"
            srcDoc={gameHtml}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-gray-500 text-sm">
            Your game will appear here once the AI generates it.
          </div>
        )}
      </div>
    </div>

    {session && session.versions?.length > 0 && (
      <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl p-4 border border-white/10">
        <h3 className="text-white font-semibold mb-2">Version History</h3>
        <div className="space-y-2 max-h-40 overflow-y-auto pr-2 text-xs">
          {session.versions.map((v) => (
            <div
              key={v.version_id}
              className="flex items-center justify-between bg-black/40 rounded-md px-3 py-2"
            >
              <div className="mr-2">
                <div className="text-gray-200 truncate max-w-[180px]">{v.label}</div>
                {v.notes && (
                  <div className="text-gray-500 truncate max-w-[180px]">{v.notes}</div>
                )}
              </div>
              <Button
                size="xs"
                variant="outline"
                className="border-purple-500 text-purple-300 hover:bg-purple-500/10"
                onClick={() => onRestore(v.version_id)}
              >
                Restore
              </Button>
            </div>
          ))}
        </div>
      </div>
    )}
  </div>
);
